import React from 'react';
import { Formik } from 'formik';
import { defaultValues, createValidationSchema, updateValidationSchema } from './types';
import { AddEventFormValues } from './types';
import { EventFormFields } from './components/EventFormFields';

interface AddEventFormProps {
  onSubmit: (values: AddEventFormValues) => void;
  onCancel: () => void;
  isEditMode?: boolean;
  initialValues?: AddEventFormValues;
  existingImageUrl?: string;
}

export const AddEventForm: React.FC<AddEventFormProps> = ({
  onSubmit,
  onCancel,
  isEditMode = false,
  initialValues = defaultValues,
  existingImageUrl,
}) => {
  const handleSubmit = (values: AddEventFormValues) => {
    onSubmit(values);
  };

  const validationSchema = isEditMode ? updateValidationSchema : createValidationSchema;

  return (
    <div className="events-form">
      <h2>{isEditMode ? 'Update Event' : 'Add New Event'} </h2>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnMount={true}
        validateOnChange={true}
        validateOnBlur={true}
        validateOnSubmit={true}
      >
        <EventFormFields
          onCancel={onCancel}
          isEditMode={isEditMode}
          existingImageUrl={existingImageUrl}
        />
      </Formik>
    </div>
  );
};
